import type React from "react";
import { Button } from "./Button";

export interface LoadMoreButtonProps {
  onClick: () => void;
  hasMore: boolean;
  loading: boolean;
  loadingText?: string;
  defaultText?: string;
}

/**
 * Reusable button component for loading more items with loading state
 */
export function LoadMoreButton({
  onClick,
  hasMore,
  loading,
  loadingText = "Loading...",
  defaultText = "Show more",
}: LoadMoreButtonProps) {
  return (
    <div className="flex justify-center mt-6">
      <Button variant="primary" onClick={onClick} disabled={!hasMore || loading}>
        {loading && (
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <title>Loading</title>
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        {loading ? loadingText : defaultText}
      </Button>
    </div>
  );
}
